'use strict';

angular.module('mandaeApp')
    .controller('PesquisarPedidoPorNumeroCtrl', function ($state, $stateParams) {

        var regexNumero = /OS(\d+)\/\d+/i;
        var match = regexNumero.exec($stateParams.numero);
        if (match && match[1]) {
            var idPedido = Number(match[1]) - 601;
            $state.go('historico.pedido', {
                idPedido: idPedido
            });
        } else {
            $state.go('pedido.redirecionar')
        }

    });